import { render, staticRenderFns } from "./AnswerImageArea.vue?vue&type=template&id=3821d4f8&scoped=true&"
import script from "./AnswerImageArea.vue?vue&type=script&lang=ts&"
export * from "./AnswerImageArea.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerImageArea.vue?vue&type=style&index=0&id=3821d4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821d4f8",
  null
  
)

export default component.exports